import $ from 'jquery';

// const shopList = {
//   noselect: {
//     name: '指定なし',
//     email: 'info@sugahara.com',
//   },
//   sghr: {
//     name: '菅原工芸硝子 本社',
//     email: 'info@sugahara.com',
//   },
//   aoyamaoffice: {
//     name: 'スガハラショップ 青山（青山オフィス）',
//     email: 'plus@sugahara.com',
//   },
//   aoyamashop: {
//     name: 'スガハラショップ 青山',
//     email: 'aoyama@sugahara.com',
//   },
//   yodoyabashi: {
//     name: 'スガハラショップ 淀屋橋',
//     email: 'yodoyabashi@sugahara.com',
//   },
//   sendai: {
//     name: 'スガハラショップ 仙台',
//     email: 'sendai@sugahara.com',
//   },
//   factory: {
//     name: 'スガハラ ファクトリーショップ',
//     email: 'shop@sugahara.com',
//   },
//   fukuoka: {
//     name: 'スガハラショップ 福岡',
//     email: 'fukuoka@sugahara.com',
//   },
//   umeda: {
//     name: 'スガハラショップ 阪急うめだ本店',
//     email: 'hankyu@sugahara.com',
//   },
//   matsuya: {
//     name: 'スガハラショップ 松屋銀座',
//     email: 'matsuya@sugahara.com',
//   },
//   cafeAoyama: {
//     name: 'Sghr café Aoyama',
//     email: 'aoyama@sghrcafe.com',
//   },
//   cafeKujukuri: {
//     name: 'Sghr café Kujukuri',
//     email: 'kujukuri@sghrcafe.com',
//   },
//   rental: {
//     name: 'スガハラショップ 青山（青山オフィス）',
//     email: 'info@sghr.glass',
//   },
//   // press: {
//   //   name: '菅原工芸硝子 本社',
//   //   email: 'press@sugahara.com',
//   // }
// };
// const typeList = {
//   product: '製品について',
//   experience: 'ガラス制作体験・見学について',
//   event: 'イベントについて',
//   retail: '小売店でのお取り扱い',
//   restaurant01: '飲食業でのご購入（新規お取り引き）',
//   restaurant02: '飲食業でのご購入（既存のお取り引きあり）',
//   rental: 'レンタルサービス Rental Sghr について',
//   material: 'ガラス建材 Sghr マテリアルズについて',
//   other: 'その他',
// };

function init() {
  const $elm = $('#c-form');

  if (!$elm[0]) {
    return;
  }
  checkform($elm);
  // setAddress();
  textareaHeight();
  // onChangeAddress();
  // onChangeType();
  // checkAgree();
}

function checkform($elm) {
  const $submit = $('.c-form__confirmBtn');
  const $heading = $('#c-form__heading');
  const heading = $heading.text();
  const $text = $('#c-form__confirmText');
  const text = $text.html();

  $submit.on('click', event => {
    let count = 0;

    $elm.find('.c-form__message').remove();
    $('.c-form__errorConfirm').remove();
    $elm.find('.c-form__error').removeClass('c-form__error');

    $elm.find('.c-form__required').each((n, val) => {
      count += checkRequired($(val));
    });

    count += checkEmail($elm.find('.c-form__email'));

    $elm.find('.c-form__required--select').each((n, val) => {
      count += checkRequiredSelect($(val));
    });

    $elm.find('.c-form__required--check').each((n, val) => {
      count += checkRequiredCheckbox($(val));
    });

    if (count > 0) {
      const $error = $elm.find('.c-form__error').eq(0);
      const $errorH = $('.p-contact__form').offset().top;
      const $headerH = $('.l-header').innerHeight();

      if ($error.find('select')[0]) {
        $error.find('select').focus();
      } else if ($error.find('textarea')[0]) {
        $error.find('textarea')[0].focus();
      } else {
        $error.find('input').focus();
      }

      $('.p-contact__form').prepend('<div class="c-form__errorConfirm">●ご入力内容に不備があります。赤字の箇所をご確認ください。</div>');

      setTimeout(() => {
        $('body, html').animate({ scrollTop: $errorH - $headerH / 2, }, 600);
      }, 500);
      event.preventDefault();
      return false;
    }

    $heading.text('入力内容のご確認');
    $text.empty().html('<p>入力内容をご確認のうえ、「送信」ボタンを押してください。</p>');

    addClickBtn(heading, text);

    return true;
  });

  function addClickBtn(h, txt) {
    const $btn = $('.wpcf7c-btn-back');

    if (!$btn[0]) {
      return;
    }

    const $form = $('.p-contact__form');
    const $el = $form.find('.wpcf7-form');

    $btn.on('click', () => {
      if ($el.hasClass('custom-wpcf7c-confirmed')) {
        $el.removeClass('custom-wpcf7c-confirmed');
        $heading.text(h);
        $text.empty().html(txt);
      }
    });
  }
}

function checkRequired($elm) {
  const $text = $elm.find('.c-form__itemName').text();
  let $name;

  if ($text.indexOf('*') >= 0) {
    $name = $text.replace('*', '');
  } else {
    $name = $text;
  }

  const message = $elm.attr('data-message') || `※${$name}を入力してください`;

  if (!$elm.find('input').val() && !$elm.find('textarea').val()) {
    showErr($elm, message);
    return 1;
  }
  return 0;
}

function checkRequiredSelect($elm) {
  const $text = $elm.find('.c-form__itemName').text();
  let $name;

  if ($text.indexOf('*') >= 0) {
    $name = $text.replace('*', '');
  } else {
    $name = $text;
  }

  const message = $elm.attr('data-message') || `※${$name}を選択してください`;

  if (!$elm.find('select').val() || $elm.find('select').val() === 'お問合わせの種類を選択してください' || $elm.find('select').val() === '講義方法を選択してください') {
    showErr($elm, message);
    return 1;
  }
  return 0;
}

function checkRequiredCheckbox($elm) {
  const $text = $elm.find('.c-form__itemName').text();
  let $name;

  if ($text.indexOf('*') >= 0) {
    $name = $text.replace('*', '');
  } else {
    $name = $text;
  }
  const message = $elm.attr('data-message') || `※${$name}を選択してください`;

  if (!$elm.find('input[type="checkbox"]:checked').val()) {
    showErr($elm, message);
    return 1;
  }
  return 0;
}

function checkEmail($elm) {
  const $text = $elm.find('.c-form__itemName').text();
  let $name;

  if ($text.indexOf('*') >= 0) {
    $name = $text.replace('*', '');
  } else {
    $name = $text;
  }

  const email = $elm.find('input').val();
  const message = $elm.attr('data-message') || `※${$name}を入力してください`;

  if (email) {
    if (!email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+\.([a-zA-Z0-9._-]+)+$/)) {
      showErr($elm, '※正しいメールアドレスを入力してください');
      return 1;
    }
  } else {
    showErr($elm, message);
    return 1;
  }
  return 0;
}

function showErr($elm, message) {
  $elm.addClass('c-form__error');
  if ($elm.find('.c-form__input').find('.wpcf7-not-valid-tip')[0]) {
    $elm.find('.c-form__input').find('.wpcf7-not-valid-tip').remove();
  }
  $elm.find('.c-form__input').append(`<span class="c-form__message">${message}</span>`);
}

function textareaHeight() {
  const $btn = $('.wpcf7c-btn-confirm');
  const $textarea = $('.c-form__input textarea');
  const $dom = $('<span style="position: absolute; display: block; top: 0; left: 0; width: 100%; opacity: 0; visibility: hidden;"></span>');
  let domH;

  $textarea.after($dom);

  $textarea.on('input', (e) => {
    const $this = $(e.currentTarget);

    $dom.text($this.val());
    domH = $dom.innerHeight() + 24;
  });

  $btn.on('click', () => {
    setTimeout(() => {
      let cfmTxtH;

      if ($('#c-form form').hasClass('custom-wpcf7c-confirmed')) {
        $textarea.css({ minHeight: domH, height: domH, });
        $('.p-contact__form').prepend('<div class="c-form__confirm">●入力内容をご確認のうえ、「送信」ボタンを押してください。</div>');

        cfmTxtH = $('.c-form__confirm').offset().top;

        $('body, html').animate({ scrollTop: cfmTxtH - 80, }, 400);
      }
    }, 1000);
  });

  $('.wpcf7c-btn-back').on('click', () => {
    if ($('.c-form__confirm')[0]) {
      $('.c-form__confirm').remove();
    }
    $textarea.css({ minHeight: '300px', height: 'auto', });
  });
}

export default {
  init,
};
